module.exports = __webpack_public_path__ + "img/GAME_PICTURELOTUS.a3d81f2f.png";